export default __webpack_public_path__ + "static/media/images-oakwood-school-logo-mark.40d4a004.svg";